import React from 'react';

function Cards(props) {
  const color = props.color
  return (
    <>
      <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.6 0.00195312C1.91044 0.00195313 1.24912 0.246531 0.761522 0.681884C0.273928 1.11724 0 1.7077 0 2.32338V3.21624H16V2.32338C16 2.01853 15.9327 1.71666 15.8021 1.43501C15.6714 1.15336 15.4799 0.897448 15.2385 0.681884C14.997 0.466319 14.7104 0.295324 14.395 0.178661C14.0795 0.0619988 13.7414 0.00195312 13.4 0.00195312H2.6ZM16 4.28767H0V7.68052C0 8.29621 0.273928 8.88667 0.761522 9.32202C1.24912 9.75738 1.91044 10.002 2.6 10.002H13.4C13.7414 10.002 14.0795 9.94191 14.395 9.82525C14.7104 9.70858 14.997 9.53759 15.2385 9.32202C15.4799 9.10646 15.6714 8.85055 15.8021 8.5689C15.9327 8.28725 16 7.98538 16 7.68052V4.28767ZM11 6.78767H13C13.1591 6.78767 13.3117 6.84411 13.4243 6.94457C13.5368 7.04504 13.6 7.1813 13.6 7.32338C13.6 7.46546 13.5368 7.60172 13.4243 7.70219C13.3117 7.80265 13.1591 7.8591 13 7.8591H11C10.8409 7.8591 10.6883 7.80265 10.5757 7.70219C10.4632 7.60172 10.4 7.46546 10.4 7.32338C10.4 7.1813 10.4632 7.04504 10.5757 6.94457C10.6883 6.84411 10.8409 6.78767 11 6.78767Z"
          fill={color}
        />
      </svg>
    </>
  );
}

export default Cards;
